import {useQuery} from 'react-query'
import {PageEditModalForm} from './PageEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialPage } from '../core/_models'

const PageEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: Page,
    error,
  } = useQuery(
    `${QUERIES.PAGES_LIST}-Page-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/pages")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <PageEditModalForm isPageLoading={isLoading} Page={{...initialPage, _id: undefined}} />
  }

  if (!isLoading && !error && Page) {
    return <PageEditModalForm isPageLoading={isLoading} Page={Page} />
  }

  return null
}

export {PageEditModalFormWrapper}
